export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./komplexbridge.vue?vue&type=template&id=56564952"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/komplexbridge.vue?vue&type=template&id=56564952
// module id = ntjB
// module chunks = 0